// Single source of truth for the pdfjs-dist worker URL.
//
// The worker must match the pdfjs API version exactly — a mismatch throws
// "The API version 'X' does not match the Worker version 'Y'" at first
// PDF parse. Previous setups fetched /pdf.worker.min.mjs from public/
// with network fallbacks, which drifts from the npm package whenever
// pdfjs-dist is upgraded without also copying the new worker into
// public/. Using Vite's `?url` import lets the bundler emit the exact
// worker shipped with the installed package, so the version always
// tracks node_modules.

import * as pdfjsLib from 'pdfjs-dist'
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

let _configured = false

export function configurePdfWorker() {
  if (_configured) return
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
  _configured = true
}

export { pdfjsLib }
